import { StageType } from '../models';

import { SHARED_ROUTES } from './shared.routes';

export const SHARED_PLATFORM_ROUTES = {
  ...SHARED_ROUTES,

  //account
  account_profile: '/account/profile',
  account_options: '/account/options',
  account_options_recordings: '/account/options/recordings',
  account_options_recordings_type: (
    type: 'webinar' | 'workshop' | 'competition'
  ) => `/account/options/recordings?tab=${type}`,
  account_options_recordings_view: '/account/options/recordings', //single recording view
  account_billing: '/account/billing',
  account_manage_subscription: '/account/subscriptions',
  account_actions_updates: '/account/profile?tab=actions-and-updates',
  //skills
  skills: '/skills',
  skills_view: '/skills', //single skill view
  //modules
  module: '/skills/modules',
  change_password_signup: '/auth/signup/change-password',
  //dashboard
  dashboard: '/dashboard',
  dashboard_help_center: '/dashboard/help-center',
  dashboard_transactions: '/dashboard/transactions',
  dashboard_baseline_assessment: '/dashboard/baseline-assessment',
  dashboard_baseline_assessment_step1: '/dashboard/baseline-assessment/step1',
  dashboard_baseline_assessment_step2: '/dashboard/baseline-assessment/step2',
  dashboard_baseline_assessment_results:
    '/dashboard/baseline-assessment/results',

  //tracks
  tracks: '/tracks',
  tracks_entrepreneurship_track: '/tracks/entrepreneurship-track',
  tracks_internship_track: '/tracks/internship-track',
  tracks_internship_track_job_board: '/tracks/internship-track/job-board',
  tracks_internship_job: (jobId: string) =>
    `/tracks/internship-track/job-board/jobs/${jobId}`,
  my_applications: 'my-applications',
  job_board: 'job-board',
  job_board_my_applications: 'job-board/my-applications',
  tracks_entrepreneurship_track_bullpen_application:
    '/tracks/entrepreneurship-track/bullpen-application',

  tracks_stage_card_view: (stage: StageType, cardId: string) =>
    `/tracks/${stage}/card/${cardId}`,
  tracks_stage_module_view: (stage: StageType, cardId: string) =>
    `/tracks/${stage}/card/modules/${cardId}`,

  //resources
  resources: '/resources',
  resources_by_category: (categoryId: string) => `/resources/${categoryId}`,
  resources_favorites: (categoryId: string) =>
    `/resources/${categoryId}?fav=true`,

  //analysis
  analysis: '/analysis',
  analysis_skills: '/analysis/skills',
  analysis_points_history: '/analysis/points-history',
  analysis_projects: '/analysis/projects',
  analysis_projects_add: '/analysis/projects/add',
  analysis_reports: '/analysis/reports',
  analysis_reports_add_step1: '/analysis/reports/add?step=1',
  analysis_reports_add_step2: '/analysis/reports/add?step=2',
  analysis_reports_add_step3: '/analysis/reports/add?step=3',
  analysis_per_module: (skillCategoryId: string) =>
    `/analysis/skills/${skillCategoryId}?type=skill`,

  //events
  events: '/events',
  eventType: '/events/type',

  //challenges
  challenges: '/challenges', //all challenges
  challenges_collections: '/challenges/collection', //single challenge collection view
  challenges_view: '/challenges', //single challenge view
  challenges_view_participate: (challengeId: string) =>
    `/challenges/${challengeId}/participate`, //single challenge view
  challenges_past_winners: (challengeId: string) =>
    `/challenges/${challengeId}/past-winners`,
  challenges_ranks_global: '/challenges/ranks/global',
  challenges_ranks_school: '/challenges/ranks/school',

  //showcase
  showcase: '/showcase',
  showcase_badges_and_certificates: '/showcase/badges-and-certificates',
  showcase_badges_and_certificates_badges:
    '/showcase/badges-and-certificates#badges',
  showcase_badges_and_certificates_certificates:
    '/showcase/badges-and-certificates#certificates',
  showcase_reflection_competitions_won: '/showcase/reflection-competitions-won',

  // rewards
  rewards: '/rewards',
  rewards_purchased: '/rewards/purchased',
  rewards_apps: '/rewards/apps',
  rewards_recordings: '/rewards/recordings',
  rewards_webinars: '/rewards/recordings/webinars',
  rewards_workshops: '/rewards/recordings/workshops',
  rewards_competitions: '/rewards/recordings/competitions',
  rewards_resources: '/rewards/recordings/resources',

  //journal
  journal: '/journal',

  // posts
  posts: '/posts',
  singlePost: (postId: string) => `/posts/${postId}`,
} as const;
